import { DetailRefundResponse, GetOrderDetailBankpayment, GetOrderDetailData } from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
import { Typography, Image, Divider, message, Alert } from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { numberFormat } from "utils/nuberFormat";
import noImage from "assets/images/no-image.png";
import { useDetailRefundList } from "hooks/useOrders";
import { getPaymentName } from "utils/convertData";


interface PaymentRefundDetailListProps  {
    refundList: DetailRefundResponse | undefined;
    setRefundList: Dispatch<SetStateAction<DetailRefundResponse | undefined>>;
    item: GetOrderDetailData | undefined;
}

const PaymentRefundDetailList:FC <PaymentRefundDetailListProps> =({
    item,
    refundList,
    setRefundList
}) => {

    // const [refundList, setRefundList] = useState<DetailRefundResponse>();
    // const { mutate } = useDetailRefundList();

    // useEffect(()=> {
    //     if (item) {
    //         mutate( item.order_id,
    //         {
    //             onSuccess: (data) => {
    //                 setRefundList(data)
    //             },
    //             onError: () => {
    //                 // message.error("ไม่มีข้อมูลการคืนเงิน");
    //             },
    //         });
    //     }    
    // },[item]);
    return (
    <>
        {(refundList?.data?.length || 0) > 0 ? 
            refundList?.data?.map((data, index) => {
                return (
                <div style={{margin:"10px 10px 10px 10px"}}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 1.5 }}>
                            <Typography.Text style={{ fontWeight: "400" }}>
                                ช่องทางการคืนเงิน
                            </Typography.Text>
                        </div>
                        <div style={{ flex: 3 }}>
                            <Typography.Text>
                                {(data.payment_type && (getPaymentName(data.payment_type,'th')) ) || 'ไม่ได้ระบุ'}
                            </Typography.Text>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 1.5 }}>
                            <Typography.Text style={{ fontWeight: "400" }}>
                                ยอดโอน
                            </Typography.Text>
                        </div>
                        <div style={{ flex: 3 }}>
                            <Typography.Text>
                                {(data.paid_amt && numberFormat(data.paid_amt) + ` บาท`) || 'ไม่ได้ระบุ'}
                            </Typography.Text>
                        </div>
                    </div><div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 1.5 }}>
                            <Typography.Text style={{ fontWeight: "400" }}>
                                วันเวลาที่โอน
                            </Typography.Text>
                        </div>
                        <div style={{ flex: 3 }}>
                            {data?.payment_date ? (
                                <Typography.Text>
                                    {data?.payment_date && formatDateWithTime(data?.payment_date)}
                                </Typography.Text>
                            ) : (
                                <Typography.Text>ไม่ได้ระบุ</Typography.Text>
                            )}
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>

                        {data?.image_slip && (
                            <>
                                <div style={{ flex: 1.5 }}>
                                    <Typography.Text style={{ fontWeight: "400" }}>
                                        สลิป
                                    </Typography.Text>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", }}>
                                    <Image
                                        width={180}
                                        src={`${data?.image_slip || noImage}`} />
                                </div>
                            </>
                        )}
                    </div>
                    <Divider />
                </div>
                )
            })
        
        :
        <div style={{margin:"10px"}}>
            <Alert
                message="ไม่พบข้อมูลการคืนเงิน"
                type="warning"
            />   
        </div>
        }
    </>
    )
} 

export default PaymentRefundDetailList